import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {StatistiquesEGAlimService} from "../../../core/services/egalim/statistiques-egalim.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";
import {UtilsService} from "../../../core/utils/utils.service";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {DateLevelEnum} from "../../../shared/date/picker/date-level-enum";
import {GraphQLService} from "../../../core/services/technique/graphql.service";
import {PointTeledeclarationEgalimDto} from "../../../core/dtos/egalim/point-teledeclaration-egalim-dto";
import {ToastService} from "../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {ErrorCode} from "@angular/compiler-cli/src/ngtsc/diagnostics";
import {StatistiqueEgalimDTO} from "../../../core/dtos/egalim/statistique-egalim-dto";
import {CoreErrorDN} from "../../../../../../pms/src/core/domain/technique/errors/CoreErrorDN";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";

@Component({
  selector: 'yo-statistiques-egalim-error-dialog',
  templateUrl: './statistiques-egalim-error-dialog.component.html',
  styleUrls: ['./statistiques-egalim-error-dialog.component.scss']
})
export class StatistiquesEgalimErrorDialogComponent implements OnInit, OnDestroy {

  public displayed: boolean = false;

  private subOpen: Subscription;

  public errors: StatError[];

  constructor(
    private utilsSvc: UtilsService,
    private statistiquesEgalimSvc: StatistiquesEGAlimService,
    private i8nSvc: InternationalizationService) {
  }

  ngOnInit(): void {
    this.initSubOpen();
  }

  ngOnDestroy() {
    this.utilsSvc.unsubscribe(this.subOpen);
  }

  initSubOpen = () => {
    this.subOpen = this.statistiquesEgalimSvc.openErrorDialog$.subscribe((responseErrors) => {
      this.errors = [];

      responseErrors.forEach(error => {
        const stat = error.entity;
        const displayError = error.values.map(e => this.i8nSvc.getLabelFromCode(e.code, e.args.split(','))).join("\r\n");

        this.errors.push({
          id: this.errors.length + 1,
          pointTeledeclarationLibelle: stat.pointTeledeclaration.libelle,
          siret: stat.pointTeledeclaration.siret,
          annee: stat.annee,
          error: displayError
        });
      });

      this.displayed = true;
    })
  }
}

class StatError {
  id: number;
  pointTeledeclarationLibelle: string;
  siret: string;
  annee: Date;
  error: string;
}
